/**
 * @param {{ className?: string }} props
 */
export function Skeleton({ className = '' }) {
  return <div className={`skeleton-shimmer rounded-xl ${className}`} />;
}
